import React from 'react'
import PropTypes from 'prop-types'
import { Icon } from 'antd'
import {
  StyledModal,
  ModalHeader,
  ModalTitle,
  CloseIcon,
  ModalDivider,
  ModalBody,
  ModalBodyText,
  InfoBox,
  InfoText,
  ModalFooter,
  CancelButton,
  ConfirmButton,
} from './styled'

const MarkTestAsReviewedModal = ({ visible, onCancel, onProceed, loading }) => {
  return (
    <StyledModal
      visible={visible}
      footer={null}
      closable={false}
      centered
      width={495}
      onCancel={onCancel}
      destroyOnClose
      maskClosable={!loading}
    >
      <ModalHeader>
        <ModalTitle>Review and Move Test</ModalTitle>
        <CloseIcon
          type="close"
          data-cy="markTestAsReviewedModalClose"
          onClick={loading ? undefined : onCancel}
        />
      </ModalHeader>
      <ModalDivider />
      <ModalBody>
        <ModalBodyText>
          Are you sure to approve all the items generated using AI?
        </ModalBodyText>
        <InfoBox>
          <Icon type="exclamation-circle" theme="outlined" />
          <InfoText>
            Once approved the test will be moved to{' '}
            <strong>&ldquo;Created By Me&rdquo;</strong>
          </InfoText>
        </InfoBox>
      </ModalBody>
      <ModalFooter>
        <CancelButton
          type="button"
          data-cy="markTestAsReviewedCancel"
          disabled={loading}
          onClick={onCancel}
        >
          Cancel
        </CancelButton>
        <ConfirmButton
          type="button"
          data-cy="markTestAsReviewedConfirm"
          disabled={loading}
          onClick={onProceed}
        >
          {loading ? <Icon type="loading" /> : 'Approve and move'}
        </ConfirmButton>
      </ModalFooter>
    </StyledModal>
  )
}

MarkTestAsReviewedModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onProceed: PropTypes.func.isRequired,
  loading: PropTypes.bool,
}

MarkTestAsReviewedModal.defaultProps = {
  loading: false,
}

export default MarkTestAsReviewedModal
